// extracted by mini-css-extract-plugin
module.exports = {"base":"PressFilter_base__rahjl"};